// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"Sidebar_sideBar__2LSS5","logo":"Sidebar_logo__1lkFv","info":"Sidebar_info__2qElO"};